module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('br'), _vm._v(" "), (_vm.memberInfo.delete_status) ? _c('div', {
    staticClass: "alert alert-info-bg alert-info-border"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.memberInfo.delete_time) + " 會員已註銷\n              ")])]) : _c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/upMember/' + _vm.memberInfo.shopper_id
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary inherit"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("編號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.user_no) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.shopper_id) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("品牌既有會員ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.vendor_custom_user_no) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.nickname) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.roleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("登入類型")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.create_account_type == 1) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/phone.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 2) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/fb.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 3) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/google.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 4) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": "/static/img/icon/line.png"
    }
  })]) : _vm._e(), (_vm.memberInfo.create_account_owner_type == 2 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(" + _vm._s(_vm.memberInfo.create_account_owner_brand_name) + ")")]) : (_vm.memberInfo.create_account_owner_type == 1 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(你訂)")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 5) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/jkos.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 6) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/car.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.create_account_type == 7) ? _c('span', [_c('img', {
    staticClass: "img-login-type img-round",
    attrs: {
      "src": "/static/img/icon/existing-member.png"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("信箱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.email || '未填寫') + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.email || '未填寫') + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.memberInfo.birth) ? _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("生日")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.birth) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("手機")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.phone) + "\n                  "), (_vm.memberInfo.is_phone_valid == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未通過")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_phone_valid == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已通過")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.roleType === 99) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("停權")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.is_suspend == 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_suspend == 1) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停權")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.roleType === 99) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("開通")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.memberInfo.is_active == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("啟動")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_active == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未啟動")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.roleType === 99) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每日交易金額上限")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.daily_trade_limit) + " 元\n                ")])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.create_time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.remark) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group inline-block"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stateType),
      expression: "stateType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stateType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getList(1)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("== 全部狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "avail"
    }
  }, [_vm._v("可使用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "used"
    }
  }, [_vm._v("已使用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "invalid"
    }
  }, [_vm._v("無法使用")])])]), _vm._v(" "), (_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "form-group inline-block"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": _vm.changeBrand
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 0 && _vm.brandSelect.value !== '0' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group inline-block"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.couponShallowList.length) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.couponShallowList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(coupon.coupon_code) + " (" + _vm._s(coupon.coupon_item_id) + ")\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.name))]), _vm._v(" "), _c('td', [(coupon.status === 0) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("未發行")]) : (coupon.status === 9) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已刪除")]) : (coupon.status === 20) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("使用中")]) : (coupon.status === 30) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已使用")]) : (coupon.is_expired) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已過期")]) : (coupon.is_void) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("已作廢")]) : (coupon.status === 10) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("可使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                        ~ " + _vm._s(_vm.getDate(coupon.avail_end_time)) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.getSourceMethodName(coupon.get_source_method)) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.get_time))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(4)])], 2)])])]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券代碼 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效期限")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("獲得來源")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("獲得時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c38a80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/MemberInfo.vue
// module id = 2396
// module chunks = 1